/**
 * Demo Mode Configuration
 *
 * This file contains all constants and configuration for demo mode.
 * Demo mode allows unauthenticated users to explore the application
 * before signing up.
 */

export const DemoConfig = {
  /**
   * Demo routes configuration
   */
  routes: {
    Profile: "/demo/profile/",
    Portfolio: "/demo/portfolio/",
    MyWallet: "/demo/my-wallet/",
    Analytics: "/demo/analytics/",
    Watchlist: "/demo/watchlist/",
    Liveshow: "/demo/liveshow/",
    CeoVsEmployee: "/demo/ceo-vs-employee/",
    MyRewards: "/demo/my-rewards/",
  },

  /**
   * Feature flags for demo mode
   */
  features: {
    /**
     * Show demo as subscribed (premium tier) to showcase all features
     */
    showSubscribedFeatures: true,
  },
} as const;
